import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { FiCheck, FiZap, FiCode, FiTrendingUp } from 'react-icons/fi';

const Subscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      await addDoc(collection(db, 'subscribers'), {
        email,
        subscribedAt: serverTimestamp(),
      });
      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error('Subscribe error:', err);
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="subscribe-page">
        <h1>You're <span className="highlight">In</span></h1>
        <p className="subtitle">
          Welcome to the community. You'll receive new articles and project updates
          straight to your inbox.
        </p>
      </div>
    );
  }

  return (
    <div className="subscribe-page">
      <h1>Join the <span className="highlight">Wicked</span> Newsletter</h1>
      <p className="subtitle">
        Engineering deep dives, project launches, and curated resources delivered
        to your inbox. Written for builders, by a builder.
      </p>

      <form className="subscribe-form" onSubmit={handleSubmit} style={{ justifyContent: 'center' }}>
        <input
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Subscribe</button>
      </form>

      {status === 'error' && (
        <p className="subscribe-success" style={{ color: '#d97755', marginTop: 12 }}>
          Something went wrong. Please try again.
        </p>
      )}

      <div className="subscribe-benefits">
        <div className="benefit-item">
          <span className="benefit-icon"><FiCheck /></span>
          <span>In-depth technical articles on system design and architecture</span>
        </div>
        <div className="benefit-item">
          <span className="benefit-icon"><FiZap /></span>
          <span>Early access to open-source projects and tools</span>
        </div>
        <div className="benefit-item">
          <span className="benefit-icon"><FiCode /></span>
          <span>Code walkthroughs and engineering best practices</span>
        </div>
        <div className="benefit-item">
          <span className="benefit-icon"><FiTrendingUp /></span>
          <span>Curated links and resources from across the industry</span>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
